const ACTIONS = {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
  SET_INITIAL_DATA: 'set-data',

  TEXT_CHANGE: 'text-change',
  TEXT_SET_ERRORS: 'text-set-errors',
  TEXT_REMOVE_ERRORS: 'text-remove-errors',

  DATE_CHANGE: 'date-change',
  DATE_SET_ERRORS: 'date-set-errors',
  DATE_REMOVE_ERRORS: 'date-remove-errors',

  RADIO_CHANGE: 'radio-change',
  RADIO_SET_ERRORS: 'radio-set-errors',
  RADIO_REMOVE_ERRORS: 'radio-remove-errors',
};

const formInfoReducer = (state, action) => {
  // //console.log("dispatch triggered", state, action);

  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading
      };
    }

    // ----- TEXT -----
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- DATES -----
    case ACTIONS.DATE_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.DATE_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.DATE_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- RADIO (reportType) -----
    case ACTIONS.RADIO_CHANGE: {
      const path = state.data[action.name];
      const setFileName = action.value === "Event" ?
        "Data Submission Summary Report by CF Version and Event Types" :
        "Data Submission Summary Report by Year and Month";
      const dateRequired = action.value === "Event";
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            radioButtons: path.radioButtons.map((button) => {
              button.isChecked = (button.value == action.value);
              return button;
            }),
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          },
          startDate: {
            ...state.data.startDate,
            validation: {
              ...state.data.startDate.validation,
              required: dateRequired,
              isInvalid: false,
              errors: []
            }
          },
          endDate: {
            ...state.data.endDate,
            validation: {
              ...state.data.endDate.validation,
              required: dateRequired,
              isInvalid: false,
              errors: []
            }
          },
          fileName: {
            ...state.data.fileName,
            value: setFileName,
            validation: {
              ...state.data.fileName.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.RADIO_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.RADIO_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- API submission -----
    case ACTIONS.CALL_API: {
      return {
        ...state,
        loading: true,
        apiError: null
      };
    }
    case ACTIONS.SUCCESS: {
      return {
        ...state,
        loading: false,
        apiError: null,
        apiResponse: action.response
      };
    }
    case ACTIONS.ERROR: {
      return {
        ...state,
        loading: false,
        apiError: action.error
      };
    }
  }
};

export { ACTIONS, formInfoReducer };
